import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import EmployeeNav from "../components/EmployeeNav";
import fetchBase from "../utils/fetchBase";

const EmployeeTimesheetsPage = () => {
    const [periods, setPeriods] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        const phone = localStorage.getItem("employee_phone");
        const authHeader = "Bearer " + localStorage.getItem("jwt_token");

        fetch(`${fetchBase}/time-log/employee/timesheets?phone=${encodeURIComponent(phone)}`, {
            headers: { Authorization: authHeader }
        })
            .then(res => res.json())
            .then(data => setPeriods(Array.isArray(data) ? data : []))
            .catch(err => console.error("Failed to fetch timesheets:", err));
    }, []);

    return (
        <>
            <EmployeeNav />
            <div style={{ maxWidth: "800px", margin: "0 auto", padding: "80px 20px 40px" }}>
                <h1 style={{ fontSize: "28px", fontWeight: "700", color: "#1d1d1f", marginBottom: "24px" }}>Timesheets</h1>

                {periods.length === 0 ? (
                    <p style={{ color: "#6e6e73", fontSize: "14px" }}>No timesheets yet.</p>
                ) : (
                    periods.map(period => (
                        <div key={period.payPeriodId} style={{ marginBottom: "30px" }}>
                            <h2 style={{ fontSize: "16px", fontWeight: "700", color: "#1d1d1f", margin: "0 0 12px" }}>
                                Period {period.startDate} – {period.endDate}
                            </h2>
                            <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                                {period.timesheets.map(ts => (
                                    <div
                                        key={ts.timesheetId}
                                        onClick={() => navigate(`/employee/timesheets/${ts.timesheetId}`)}
                                        style={{
                                            background: "#fff", border: "1px solid #e0e0e0", borderRadius: "12px",
                                            padding: "14px 16px", cursor: "pointer",
                                            display: "flex", justifyContent: "space-between", alignItems: "center"
                                        }}
                                    >
                                        <span style={{ fontWeight: 600, fontSize: "14px", color: "#1d1d1f" }}>{ts.clientName}</span>
                                        <span style={{
                                            fontSize: "12px", fontWeight: 600,
                                            color: ts.hasEmployeeSignature ? "#34c759" : "#ff9500"
                                        }}>
                                            {ts.hasEmployeeSignature ? "Signed" : "Pending"}
                                        </span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    ))
                )}
            </div>
        </>
    );
};

export default EmployeeTimesheetsPage;